import React from 'react'
import LeftIcon from '@mui/icons-material/ChevronLeft'
import RightIcon from '@mui/icons-material/ChevronRight'
import IconButton from '@mui/material/IconButton'
import { i18n } from '../../index'
import css from './monthDisplay.css'
type MonthDisplayProps = {
  selectedMonth: string
  onMonthChange: (...args: Array<any>) => any
}

const MonthDisplay = ({ selectedMonth, onMonthChange }: MonthDisplayProps) => (
  <h3 className={css.monthDisplayContainer}>
    {i18n.t('reporting.label.wastage.selectedMonth')}
    <div className={css.monthDisplay}>
      <IconButton className={css.monthButton} onClick={() => onMonthChange(-1)}>
        <LeftIcon />
      </IconButton>
      <div className={css.month}>{selectedMonth}</div>
      <IconButton className={css.monthButton} onClick={() => onMonthChange(1)}>
        <RightIcon />
      </IconButton>
    </div>
  </h3>
)

export default MonthDisplay
